import {Component, computed, effect, inject, input, model} from '@angular/core';
import {NotFoundComponent} from "../../not-found/not-found.component";
import {Page, SrmPointSummaryReport, SrmPointSummaryReportSearchParam} from "../../../../generated-model/model";
import {DecimalPipe} from "@angular/common";
import {IgnoreNullHttpParams} from "../../commons/Ignore-null-http-params";
import {SrmPointSummaryReportResource} from "../../../service/SrmPointSummaryReportResource";
import {NgbPagination} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-point-summary-report-table',
  standalone: true,
  imports: [
    NotFoundComponent,
    DecimalPipe,
    NgbPagination
  ],
  templateUrl: './point-summary-report-table.component.html',
  styleUrl: './point-summary-report-table.component.scss'
})
export class PointSummaryReportTableComponent {
  pageDataProvince = model<Page<SrmPointSummaryReport>>({number: 0, size: 50});
  currentMonth = computed(() => this.pageDataProvince()?.content?.[0]?.currMonth);
  prevMonth = computed(() => this.pageDataProvince()?.content?.[0]?.prevMonth);
  params = input<SrmPointSummaryReportSearchParam>();
  srmPointSummaryReportResource = inject(SrmPointSummaryReportResource);

  constructor() {
    effect(() => {
      this.currentMonth();
      this.prevMonth();
      console.log('this.prevMonth', this.prevMonth());
      console.log('this.currMonth', this.currentMonth());
    });
  }

  searchProvince(page: number = 1) {
    const param = IgnoreNullHttpParams.fromObject({
      ...this.params(),
      page: page - 1,
      size: this.pageDataProvince().size,
      sort: 'hmainOp.htitle'
    })
    this.srmPointSummaryReportResource.searchProvince(param)
      .subscribe(e => {
        this.pageDataProvince.set(e);
      });
  }
}
